import { MinusIcon, PlusIcon } from "@heroicons/react/24/outline";
import React from "react";

import { Label } from "@fronterahealth/frontera-ui-components";

interface ZoomButtonsProps {
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
}

export const ZoomButtons: React.FC<ZoomButtonsProps> = ({ zoom, setZoom }) => {
  return (
    <div className="flex justify-end items-end w-full gap-[10px] mb-2">
      <PlusIcon
        className="h-4 w-5 text-text-secondary cursor-pointer"
        onClick={() => setZoom((z) => Math.min(z + 25, 500))}
      />
      <Label size="extra-small">{zoom}%</Label>
      <MinusIcon
        className="h-4 w-5 text-text-secondary cursor-pointer"
        onClick={() => setZoom((z) => Math.max(z - 25, 25))}
      />
    </div>
  );
};
